import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

import { FieldLabel } from '../Retails.styles';

export const VariantLabel = styled(FieldLabel)`
    margin-top: ${getPurpurSpacing('300')};
`;

export const OutOfStockLabel = styled.span`
    padding-left: 1rem;
    background-color: unset;
    color: ${getPurpurColor('red600')};
    font-size: 0.875rem;
    font-weight: normal;
`;

export const BadgeBlockContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('150')};
    padding-bottom: ${getPurpurSpacing('300')};
`;
